import { DEFAULT_MODE, makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { middle, SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';
import { WIDTH as LEFT_WIDTH, SPACER } from '../../../tornado/pairing/selector/pairingSelector.style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  separator: makeThemeColor(PRIMARY, 0.3),
};

export { LEFT_WIDTH, SPACER };

export const LOGO_HEIGHT = {
  [HD]: 96,
  [FULL_HD]: 152,
};

export const ICON_MARGIN_TOP = {
  ...safetyMargins.vertical,
};

export const ICON_MARGIN_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const top = ICON_MARGIN_TOP[screenSize] + LOGO_HEIGHT[screenSize] + ICON_MARGIN_BOTTOM[screenSize];
  const containerHeight = SCREEN_HEIGHT[screenSize] - top - safetyMargins.vertical[screenSize];
  const rightWidth =
    SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize] * 2 - LEFT_WIDTH[screenSize] - SPACER[screenSize];

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    CustomerIcon: {
      y: ICON_MARGIN_TOP[screenSize],
      mountX: 0.5,
      x: middle,
      h: LOGO_HEIGHT[screenSize],
    },
    Left: {
      y: top,
      h: containerHeight,
    },
    Right: {
      x: safetyMargins.horizontal[screenSize] + LEFT_WIDTH[screenSize] + SPACER[screenSize],
      y: top,
      h: containerHeight,
      w: rightWidth,
      Mobile: {
        visible: false,
        h: containerHeight,
        w: rightWidth,
      },
      Desktop: {
        visible: false,
        h: containerHeight,
        w: rightWidth,
      },
    },
  };
};
